<template>
<div>
  <b-card no-body>
    <div class="m-1">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <h3>Danh sách khai báo BI Report</h3>
        </b-col>

        <b-col
          cols="12" md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0">
          
          <b-button
            variant="primary"
            @click="New()" >
            Thêm BI Report
          </b-button>
        </b-col>

      </b-row>

    </div>
    <vue-good-table
        :columns="columns"
        :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
        :line-numbers="true"
      >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Status -->
        <span v-if="props.column.field === 'ICON'">
          <feather-icon :icon="props.row.ICON"/>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item  @click="Edit(props.row)">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="Delete(props.row)">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="ml-1 mr-1 mb-1 d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10','50','100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
  <b-modal id="modal-edit" size="lg" :title="modal_title" @ok="handleOk">
    <validation-observer ref="simpleRules">
      <b-row>
        <b-col cols="6">
          <validation-provider name="Report Code" #default="{ errors }" rules="required">
            <b-form-group label="Report Code" >
              <b-form-input :state="errors.length > 0 ? false:null" v-model="currentReport.CODE" placeholder="Report Code"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider name="Report Name" #default="{ errors }" rules="required">
            <b-form-group label="Report Name" >
              <b-form-input :state="errors.length > 0 ? false:null" v-model="currentReport.NAME" placeholder="Report Name"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider name="Report Long Name" #default="{ errors }" rules="required">
            <b-form-group label="Report Long Name" >
              <b-form-input :state="errors.length > 0 ? false:null" v-model="currentReport.LONG_NAME" placeholder="Report Long Name"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider name="Report Parent" #default="{ errors }" rules="required">
            <b-form-group label="Report Parent" >
              <Select2 :state="errors.length > 0 ? false:null" v-model="currentReport.PARENT_CODE" :options="parentList.filter(i=>i.id !==currentReport.CODE)"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="4">
          <validation-provider name="Level" #default="{ errors }" rules="required">
            <b-form-group label="Report Level" >
              <Select2 :state="errors.length > 0 ? false:null" v-model="currentReport.LEVEL_INDEX" :options="['0','1','2','3']"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="4">
          <validation-provider name="Report Order" #default="{ errors }" rules="required">
            <b-form-group label="Report Order" >
              <b-form-input type="number" :state="errors.length > 0 ? false:null" v-model="currentReport.ORDER_INDEX" placeholder="Report Order"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="4">
          <validation-provider name="Report Icon" #default="{ errors }" rules="required">
            <b-form-group label="Report Icon" >
              <v-select v-model="currentReport.ICON" :state="errors.length > 0 ? false:null" :options="icons" label="title">
                <template slot="option" slot-scope="option">
                    <feather-icon :icon="option.title"/>
                    <span class="pl-1">{{ option.title }}</span>
                </template>
                <template slot="selected-option" slot-scope="option">
                    <feather-icon :icon="option.title"/>
                    <span class="pl-1">{{ option.title }}</span>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </validation-observer>
    <div class="border rounded bg-light">
      <b-row class="p-1">
        <b-col cols="12" md="6">
          <h5><feather-icon icon="GridIcon"/> Danh sách báo cáo BI</h5>
        </b-col>
        <b-col cols="12" md="6" class="d-flex align-items-center justify-content-end mb-1 mb-md-0">
          <b-button variant="primary" class="btn-sm" @click="biNew()" >Thêm BI Report</b-button>
        </b-col>
      </b-row>
      <vue-good-table
          :columns="[{label:'Tiêu đề',field:'title'},{label:'BI Report',field:'bi_report_path'},{label:'',field:'action'}]"
          :rows="currentReport.TABS" :line-numbers="true">
        <template slot="table-row" slot-scope="props">
          <!-- Column: Action -->
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template v-slot:button-content>
                  <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25"/>
                </template>
                <b-dropdown-item  @click="biEdit(props.row)">
                  <feather-icon icon="Edit2Icon" class="mr-50"/><span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item @click="biDelete(props.row)">
                  <feather-icon icon="TrashIcon" class="mr-50"/><span>Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </b-modal>
  <b-modal size="lg" id="modal-bi-report" title="BI Report Config" @ok="handleBiOk">
    <validation-observer ref="simpleRulesBI">
      <b-row>
        <b-col cols="12">
          <validation-provider #default="{ errors }" rules="required">
            <b-form-group label="Tiêu đề báo cáo" >
              <b-form-input :state="errors.length > 0 ? false:null" v-model="currentBiReport.title" placeholder="Tiêu đề báo cáo"/>
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Chọn báo cáo trên BI">
            <validation-provider #default="{ errors }" rules="required">
              <Select2 :state="errors.length > 0 ? false:null" v-model="currentBiReport.bi_report_path" :options="biReport"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BFormSelect,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,BModal,BFormCheckbox,BFormGroup,VBTooltip } from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import router from '@/router'
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import Select2 from 'v-select2-component';

export default {
  components: {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,vSelect,
    FeatherIcon,BModal,BFormGroup,BFormCheckbox,
    ValidationProvider,BFormSelect,ValidationObserver,VueGoodTable,Select2
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted(){
    this.fetchReport();
    useJwt.get('listReport', {}).then(response =>{
      this.biReport = response.data.result;
    })
  },
  methods: {
    fetchReport: function() {
      useJwt.get('report', {})
        .then(response =>{
          this.parentList = [{id:0,text:'Nhóm báo cáo gốc'}]
          this.rows = response.data.result;
          this.rows.forEach(e => {
            this.parentList.push({id: e.CODE,text: e.NAME})
            if (e.TABS === null || e.TABS === ""){
              e.TABS = []
            }else{
              e.TABS = JSON.parse(e.TABS)
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Lỗi lấy danh sách báo cáo',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    handleBiOk(){

    },
    Edit(item) {
      this.currentReport = item;
      this.modal_title= "Cập nhật BI Report"
      this.$bvModal.show('modal-edit')
    },
    New(){
      this.currentReport={TABS:[]}
      this.modal_title= "Thêm mới BI Report"
      this.$bvModal.show('modal-edit')
    },
    biEdit(item) {
      this.currentBiReport = item;
      this.$bvModal.show('modal-bi-report')
    },
    biNew(){
      this.currentBiReport={}
      this.$bvModal.show('modal-bi-report')
    },
    biDelete(item){
      this.currentReport.TABS = this.currentReport.TABS.filter(i => i.bi_report_path != item.bi_report_path)
    },
    async Delete(item) {
      this.currentReport = item;
      var res = await this.$bvModal.msgBoxConfirm('Vui lòng xác nhận bạn muốn xoá BI Report: '+item.NAME, {title: 'Please Confirm',size: 'sm',})
      if (res){
        useJwt.delete(`report/${this.currentItem.CODE}`, {})
        .then(response =>{
          this.fetchReport();
          this.$toast({component: ToastificationContent,props: {title: 'Xoá BI Report thành công!',icon: 'CheckSquareIcon',variant: 'primary'}})
        })
        .catch(error => {
          console.log(error);
          this.$toast({component: ToastificationContent,props: {title: 'Lỗi xoá BI Report',icon: 'AlertTriangleIcon',variant: 'danger'}})
        })
      }
    },
    async handleBiOk(){
      var validate = await this.$refs.simpleRulesBI.validate().then(success => {return success;});
      if (!validate){
        this.$toast({component: ToastificationContent,props: {title: 'Vui lòng kiểm tra dữ liệu!',icon: 'AlertTriangleIcon',variant: 'warning'}})
        return;
      }
      if ( this.currentReport.TABS.filter(i => i.id === this.currentBiReport.id).length>0){
        this.currentReport.TABS = this.currentReport.TABS.filter(i => i.id != this.currentBiReport.id)
        this.currentReport.TABS.push(JSON.parse(JSON.stringify(this.currentBiReport)))
      }else{
        let x = JSON.parse(JSON.stringify(this.currentBiReport));
        x.id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8);
        this.currentReport.TABS.push(x)
      }
    },
    async handleOk(bvModalEvt){
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then(success => {return success;});
      if (!validate){
        this.$toast({component: ToastificationContent,props: {title: 'Vui lòng kiểm tra dữ liệu!',icon: 'AlertTriangleIcon',variant: 'warning'}})
        return;
      }
      if (this.modal_title=="Cập nhật BI Report"){
        useJwt.put(`report/${this.currentReport.CODE}`, {
          code: this.currentReport.CODE,
          name: this.currentReport.NAME,
          longName: this.currentReport.LONG_NAME,
          level: this.currentReport.LEVEL_INDEX,
          order: this.currentReport.ORDER_INDEX,
          parentCode: this.currentReport.PARENT_CODE,
          icon: this.currentReport.ICON,
          tabs: JSON.stringify(this.currentReport.TABS)
        })
        .then(response =>{
          this.fetchReport();
          this.$bvModal.hide('modal-edit')
          this.$toast({component: ToastificationContent,props: {title: 'Cập nhật thành công!',icon: 'CheckSquareIcon',variant: 'primary'}})
        })
        .catch(error => {
          console.log(error);
          this.$toast({component: ToastificationContent,props: {title: 'Lỗi cập nhật BI Report',icon: 'AlertTriangleIcon',variant: 'danger'}})
        })
      }else{
        useJwt.post('report', {
          code: this.currentReport.CODE,
          name: this.currentReport.NAME,
          longName: this.currentReport.LONG_NAME,
          level: this.currentReport.LEVEL_INDEX,
          order: this.currentReport.ORDER_INDEX,
          parentCode: this.currentReport.PARENT_CODE,
          icon: this.currentReport.ICON,
          tabs: JSON.stringify(this.currentReport.TABS)
        })
        .then(response =>{
          this.fetchReport();
          this.$bvModal.hide('modal-edit')
          this.$toast({component: ToastificationContent,props: {title: 'Thêm mới thành công!',icon: 'CheckSquareIcon',variant: 'primary'}})
        })
        .catch(error => {
          console.log(error);
          this.$toast({component: ToastificationContent,props: {title: 'Lỗi thêm mới BI Report',icon: 'AlertTriangleIcon',variant: 'danger'}})
        })
      }
    },
  },
  data() {
    return {
      pageLength: 10,
      modal_title:'',
      columns: [
        {
          label: 'Report Code',
          field: 'CODE',
          filterOptions: {enabled: true},
        },
        {
          label: 'Report Name',
          field: 'NAME',
          filterOptions: {enabled: true},
        },
        {
          label: 'Long Name',
          field: 'LONG_NAME',
          filterOptions: {enabled: true},
        },
        {
          label: 'Icon',
          field: 'ICON',
          tdClass: 'text-center',
        },
        {
          label: 'Level',
          field: 'LEVEL_INDEX',
          filterOptions: {enabled: true, filterDropdownItems: ['0','1','2','3'],},
          width: '90px',
          tdClass: 'text-center',
        },
        {
          label: 'Order',
          field: 'ORDER_INDEX',
          filterOptions: {enabled: true},
          width: '90px',
          tdClass: 'text-center',
        },
        {
          label: 'Action',
          field: 'action',
          width: '50px',
        },
      ],
      rows: [],
      parentList: [],
      searchTerm: '',
      currentReport: {},
      currentBiReport: {},
      biReport: [],
      icons: ['ActivityIcon','AirplayIcon','AlertCircleIcon','AlertOctagonIcon','AlertTriangleIcon','AlignCenterIcon','AlignJustifyIcon','AlignLeftIcon','AlignRightIcon','AnchorIcon','ApertureIcon','ArchiveIcon','ArrowDownCircleIcon','ArrowDownLeftIcon','ArrowDownRightIcon','ArrowDownIcon','ArrowLeftCircleIcon','ArrowLeftIcon','ArrowRightCircleIcon','ArrowRightIcon','ArrowUpCircleIcon','ArrowUpLeftIcon','ArrowUpRightIcon','ArrowUpIcon','AtSignIcon','AwardIcon','BarChart2Icon','BarChartIcon','BatteryChargingIcon','BatteryIcon','BellOffIcon','BellIcon','BluetoothIcon','BoldIcon','BookOpenIcon','BookIcon','BookmarkIcon','BoxIcon','BriefcaseIcon','CalendarIcon','CameraOffIcon','CameraIcon','CastIcon','CheckCircleIcon','CheckSquareIcon','CheckIcon','ChevronDownIcon','ChevronLeftIcon','ChevronRightIcon','ChevronUpIcon','ChevronsDownIcon','ChevronsLeftIcon','ChevronsRightIcon','ChevronsUpIcon','ChromeIcon','CircleIcon','ClipboardIcon','ClockIcon','CloudDrizzleIcon','CloudLightningIcon','CloudOffIcon','CloudRainIcon','CloudSnowIcon','CloudIcon','CodeIcon','CodepenIcon','CodesandboxIcon','CoffeeIcon','ColumnsIcon','CommandIcon','CompassIcon','CopyIcon','CornerDownLeftIcon','CornerDownRightIcon','CornerLeftDownIcon','CornerLeftUpIcon','CornerRightDownIcon','CornerRightUpIcon','CornerUpLeftIcon','CornerUpRightIcon','CpuIcon','CreditCardIcon','CropIcon','CrosshairIcon','DatabaseIcon','DeleteIcon','DiscIcon','DivideCircleIcon','DivideSquareIcon','DivideIcon','DollarSignIcon','DownloadCloudIcon','DownloadIcon','DribbbleIcon','DropletIcon','Edit2Icon','Edit3Icon','EditIcon','ExternalLinkIcon','EyeOffIcon','EyeIcon','FacebookIcon','FastForwardIcon','FeatherIcon','FigmaIcon','FileMinusIcon','FilePlusIcon','FileTextIcon','FileIcon','FilmIcon','FilterIcon','FlagIcon','FolderMinusIcon','FolderPlusIcon','FolderIcon','FramerIcon','FrownIcon','GiftIcon','GitBranchIcon','GitCommitIcon','GitMergeIcon','GitPullRequestIcon','GithubIcon','GitlabIcon','GlobeIcon','GridIcon','HardDriveIcon','HashIcon','HeadphonesIcon','HeartIcon','HelpCircleIcon','HexagonIcon','HomeIcon','ImageIcon','InboxIcon','InfoIcon','InstagramIcon','ItalicIcon','KeyIcon','LayersIcon','LayoutIcon','LifeBuoyIcon','Link2Icon','LinkIcon','LinkedinIcon','ListIcon','LoaderIcon','LockIcon','LogInIcon','LogOutIcon','MailIcon','MapPinIcon','MapIcon','Maximize2Icon','MaximizeIcon','MehIcon','MenuIcon','MessageCircleIcon','MessageSquareIcon','MicOffIcon','MicIcon','Minimize2Icon','MinimizeIcon','MinusCircleIcon','MinusSquareIcon','MinusIcon','MonitorIcon','MoonIcon','MoreHorizontalIcon','MoreVerticalIcon','MousePointerIcon','MoveIcon','MusicIcon','Navigation2Icon','NavigationIcon','OctagonIcon','PackageIcon','PaperclipIcon','PauseCircleIcon','PauseIcon','PenToolIcon','PercentIcon','PhoneCallIcon','PhoneForwardedIcon','PhoneIncomingIcon','PhoneMissedIcon','PhoneOffIcon','PhoneOutgoingIcon','PhoneIcon','PieChartIcon','PlayCircleIcon','PlayIcon','PlusCircleIcon','PlusSquareIcon','PlusIcon','PocketIcon','PowerIcon','PrinterIcon','RadioIcon','RefreshCcwIcon','RefreshCwIcon','RepeatIcon','RewindIcon','RotateCcwIcon','RotateCwIcon','RssIcon','SaveIcon','ScissorsIcon','SearchIcon','SendIcon','ServerIcon','SettingsIcon','Share2Icon','ShareIcon','ShieldOffIcon','ShieldIcon','ShoppingBagIcon','ShoppingCartIcon','ShuffleIcon','SidebarIcon','SkipBackIcon','SkipForwardIcon','SlackIcon','SlashIcon','SlidersIcon','SmartphoneIcon','SmileIcon','SpeakerIcon','SquareIcon','StarIcon','StopCircleIcon','SunIcon','SunriseIcon','SunsetIcon','TabletIcon','TagIcon','TargetIcon','TerminalIcon','ThermometerIcon','ThumbsDownIcon','ThumbsUpIcon','ToggleLeftIcon','ToggleRightIcon','ToolIcon','Trash2Icon','TrashIcon','TrelloIcon','TrendingDownIcon','TrendingUpIcon','TriangleIcon','TruckIcon','TvIcon','TwitchIcon','TwitterIcon','TypeIcon','UmbrellaIcon','UnderlineIcon','UnlockIcon','UploadCloudIcon','UploadIcon','UserCheckIcon','UserMinusIcon','UserPlusIcon','UserXIcon','UserIcon','UsersIcon','VideoOffIcon','VideoIcon','VoicemailIcon','Volume1Icon','Volume2Icon','VolumeXIcon','VolumeIcon','WatchIcon','WifiOffIcon','WifiIcon','WindIcon','XCircleIcon','XOctagonIcon','XSquareIcon','XIcon','YoutubeIcon','ZapOffIcon','ZapIcon','ZoomInIcon','ZoomOutIcon']
    }
  },
}
</script>
<style>
.vgt-table td,.vgt-table th{
  padding: 0.35em 0.55em !important;
  vertical-align: middle !important;
  font-size: 1rem;
}
.vgt-table th{
  text-align: center;
}
.select2-selection--single{
    border: 1px solid #2B938C;
    border-radius: 1.5rem;
}
.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMDBCMEVDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==") center / contain no-repeat;
}
.select2-selection__arrow{
  background: none;
  display: none !important;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>